<ion-toolbar>
  <ion-buttons slot="start">
    <ion-button
      item-start
      icon-only
      fill="clear"
      color="dark"
      (click)="previous($event)"
      [disabled]="disabled"
    >
      <ion-icon name="arrow-back"></ion-icon>
    </ion-button>
  </ion-buttons>
  <ion-title class="ion-text-center">
    <ion-button
      id="dateLabel"
      color="dark"
      icon-right
      fill="clear"
      (click)="changeDate()"
      [disabled]="disabled"
      *ngIf="hideGroupBy"
    >
      {{ title }}
      <ion-icon name="chevron-down"></ion-icon>
    </ion-button>
    <ion-button
      id="dateLabel"
      color="dark"
      icon-right
      fill="clear"
      (click)="changeDate()"
      [disabled]="disabled"
      *ngIf="!hideGroupBy"
    >
      {{ title }}
      <ion-icon name="chevron-down"></ion-icon>
    </ion-button>
    <ion-button
      color="dark"
      icon-right
      fill="clear"
      (click)="changeRangeGrouping($event)"
      [disabled]="disabled"
      *ngIf="!hideGroupBy"
    >
      {{ groupBy | titlecase }}
      <ion-icon name="chevron-down"></ion-icon>
    </ion-button>
  </ion-title>
  <ion-buttons slot="end">
    <ion-button
      item-end
      icon-only
      fill="clear"
      color="dark"
      (click)="next()"
      [disabled]="disabled"
    >
      <ion-icon name="arrow-forward"></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-toolbar>
